/*
----- Sticky ----- 
- TODO: Trying to globalise the functionality used in the basket with sticky basket summary.
- This functionality is build ontop of foundations https://get.foundation/sites/docs/sticky.html but due to how complex the header can be due to its own sticky functionality there is some stuff we need work out before we initialise an instance of foundation's stick on an element other than the header.
*/


var instances = {};

function getInstanceId(context) {
    if (!context) {
        AXISDebug.output(3,"Sticky: No context provided");
        return false;
    }
    let id = context.attr(expressSelectors()['axis-sticky']['initialise']);
    if (!id) {
        AXISDebug.output(3,"Sticky: No Id found, has this element been initialised?");
        return false;
    } else {
        return id;
    }
}

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setStickyContainer(id, value) {
    return instances[id]['sticky-container'] = value;
}

function getStickyContainer(id) {
    return instances[id]['sticky-container'];
}

function setAnchor(id, value) {
    return instances[id]['anchor'] = value;
}

function getAnchor(id) {
    return instances[id]['anchor'];
}

function setTopAnchor(id, value) {
    return instances[id]['top-anchor'] = value;
}

function getTopAnchor(id) {
    return instances[id]['top-anchor'];
}

function setBottomAnchor(id, value) {
    return instances[id]['bottom-anchor'] = value;
}

function getBottomAnchor(id) {
    return instances[id]['bottom-anchor'];
}

function setContainerClass(id, value) {
    return instances[id]['container-class'] = value;
}

function getContainerClass(id) {
    return instances[id]['container-class'];
}

function setFoundationInstance(id, value) {
    return instances[id]['foundation-instance'] = value;
}

function getFoundationInstance(id) {
    return instances[id]['foundation-instance'];
}

function setMarginTop(id, value) {
    return instances[id]['margin-top'] = value;
}

function getMarginTop(id) {
    return instances[id]['margin-top'];
}

function setStickyBreakpoint(id, value) {
    return instances[id]['breakpoint'] = value;
}

function getStickyBreakpoint(id) {
    return instances[id]['breakpoint'];
}

function setIsHeader(id, value) {
    return instances[id]['is-header'] = value;
}

function getIsHeader(id) {
    return instances[id]['is-header'];
}

function initialiseAll() {
    let selector = $('[' + expressSelectors()['axis-sticky']['initialise'] + ']');
    if (selector.length > 0) {
        selector.each(function() {
           // Grab context.
           let context = $(this);
           // Initialise.
           let init = initialise(context); 
        })
    }
}

function initialise(context, config = {}) {
    if (context.length == 0) {
        AXISDebug.output(3,"Sticky: Context is not defined.", context);
        return false;
    }
    let id = context.attr(expressSelectors()['axis-sticky']['initialise']);
    // If no Id then generate one.
    if (!id) {
        context.attr(expressSelectors()['axis-sticky']['initialise'], generateId());
        id = context.attr(expressSelectors()['axis-sticky']['initialise']);
        instances[id] = {};
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Sticky: Instance already initialised skipping.");
        }
        return false;
    }

    // Get Config.
    let anchor = context.data('anchor');
    // Fallback.
    if (!anchor && config.hasOwnProperty('anchor')) {
        anchor = config['anchor'];
    }
    let topAnchor = context.data('top-anchor');
    // Fallback.
    if (!topAnchor && config.hasOwnProperty('top-anchor')) {
        topAnchor = config['top-anchor'];
    }
    let bottomAnchor = context.data('btm-anchor');
    // Fallback.
    if (!bottomAnchor && config.hasOwnProperty('btm-anchor')) {
        bottomAnchor = config['btm-anchor'];
    }
    let containerClass = context.data('container-class'); 
    let marginTop = context.data('margin-top');
    let breakpoint = context.data('breakpoint');
    // Fallback #1
    if (!breakpoint && config.hasOwnProperty('breakpoint')) {
        breakpoint = config['breakpoint'];
    }
    // Fallback #2
    if (breakpoint == undefined) {
        breakpoint = "large";
    }
    
    // Fallback.
    if (marginTop == undefined) {
        marginTop = 0;
    }
    // Fallback.
    if (!containerClass) {
        containerClass = id + "-sticky-container";
    }
    // Work out the container.
    let stickyContainer = (anchor ? $('#' + anchor) : context.parents('[data-sticky-container]'));

    // Assign config to instance.
    setContext(id, context);
    setStickyContainer(id, stickyContainer);
    setAnchor(id, anchor);
    setTopAnchor(id, topAnchor);
    setBottomAnchor(id, bottomAnchor);
    setContainerClass(id, containerClass);
    setMarginTop(id, marginTop);
    setStickyBreakpoint(id, breakpoint);

    // Initialise foundation's sticky.
    return initialiseSticky(id);
}

function initialiseSticky(id) {
    // Get sticky breakpoint.
    //let stickyBreakpoint = getStickyBreakpoint(id);
    let context = getContext(id);
    let stickyContainer = getStickyContainer(id);
    // Add container class(s) to sticky container.
    stickyContainer.addClass('sticky-container');

    
    // Working on a concept to derive the top anchor position from the top anchor id more accurately 843473.
    // let topAnchorId = getTopAnchor(id);

    // let topAnchorPosition = undefined
    // if (topAnchorId) {
    //     topAnchorId = topAnchorId.split(':')[0];
    //     // Find top anchor context.
    //     let topAnchorContext = $('#' + topAnchorId);
    //     if (topAnchorContext.length) {
    //         topAnchorPosition = topAnchorContext.offset().top;

    //         topAnchorPosition = (topAnchorPosition - getHeaderSize())

    //     }
    // }

    // Build sticky config from instace.
    let stickyOptions = {
        container: "<div data-sticky-content-container></div>",
        anchor: getAnchor(id),
        // topAnchor: (topAnchorPosition ? topAnchorPosition : getTopAnchor(id)),
        topAnchor: getTopAnchor(id),
        btmAnchor: getBottomAnchor(id),
        containerClass: getContainerClass(id),
        stickyOn: getStickyBreakpoint(id),
        marginTop: getMarginTop(id),
        checkEvery: 0
    }
    // Create foundation instance.
    let init = new Foundation.Sticky(context, stickyOptions);
    // Save instance.
    setFoundationInstance(id, init);
    // Is this the header?
    let isHeader = (context.parents('header').length > 0);
    setIsHeader(id, isHeader);
    // Add listeners.
    stickyListeners(id);
    // If this is the header then re-calculate other sticky margin, otherwise if the page was loaded halfway down you could end up with a gap between the sticky header and the other sticky elements.
    if (isHeader) {
        reCalculateHeaderMargin(id);
    }
    // If current breakpoint is less than sticky breakpoint then destroy instance to prevent DOM manipulation on lower breakpoints. https://github.com/foundation/foundation-sites/issues/9892
    //if (currentBreakpoint() < getBreakpoint(stickyBreakpoint)) {
        // Destroy doesn't clean up these event handlers causing exceptions.
        //getFoundationInstance(id).$element.off('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd');
        // Destroy foundation instance.
        //getFoundationInstance(id).$element.foundation('_destroy');
    //}
}

// Normally called after AJAX to clean up any instances that are no longer in the DOM
function instancesCleanup() {
    for (let instance in instances) {
        // Get instance id.
        let id = instance;
        cleanup(id);
    }
}

// Check if instance is still in the DOM if not then remove.
function cleanup(id) {
    // Check if instance exist's in DOM.
    if (!$('[' + expressSelectors()['axis-sticky']['initialise'] + '="' + id + '"]').length) {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Sticky: Instance no longer in DOM, Removing instance from memory.", id);
        }
        // Remove instance.
        delete instances[id];

        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Sticky: Remaining instances in memory after cleanup", instances);
        }
        // If cleanup has ran then return true.
        return true;
    } else {
        // If nothing to clean up then return false.
        return false;
    }
}

$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
    for (let instance in instances) {
        // Get instance id.
        let id = instance;
        // If cleanup has ran then skip.
        if (cleanup(id)) {
            continue;
        }
        // Get context.
        let context = getContext(id);
        // Is this the header?
        let isHeader = (context.parents('header').length > 0);
        // Get sticky breakpoint.
        let stickyBreakpoint = getStickyBreakpoint(id);
        // Recalculate element size on breakpoint change, this will be context element + container, this will also iron out any inconsistanies with AJAX'd in content as well ( belt and braces ). 
        instances[id]['foundation-instance']['$element'].foundation('_calc', true);
        // On breakpoint change re-calulate each instance margin top to accommodate the sticky header ( yes there is a technically limitation here to how many sticky items we can have at once. ). 
        if (newSize == getStickyBreakpoint(id) && isHeader) {
            // Loop through instance recaluting the margin top based on the header.
            instancesCalculateMargin(id);
        }
        // Suppressing this completely as this is causing issues with the back to top mechanism.
        // If current breakpoint is less than sticky breakpoint then destroy instance to prevent DOM manipulation on lower breakpoints. https://github.com/foundation/foundation-sites/issues/9892
        // if (currentBreakpoint() < getBreakpoint(stickyBreakpoint)) {
        //     // Destroy doesn't clean up these event handlers causing exceptions.
        //     getFoundationInstance(id).$element.off('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd');
        //     // Destroy foundation instance.
        //     getFoundationInstance(id).$element.foundation('destroy');

        //     setFoundationInstance(id, undefined);

        //     // Because we have just destroyed all instances thanks foundation we now need to re-initialise. https://get.foundation/sites/docs/javascript.html#initializing
        //     initialiseSticky(id);
        // } else {
        //     initialiseSticky(id);
        // }
    }
});

function stickyListeners(id) {
    // Get current instance context.
    let context = getContext(id);
    
    /*
    Events that get fired as foundation's documentation leave this out.
    - sticky.zf.unstuckfrom:top
    - sticky.zf.unstuckfrom:bottom
    - sticky.zf.stuckto:top
    - sticky.zf.stuckto:bottom

    */

    // $(window).on('scroll', function() {
    //     let container = $('#' + getAnchor(id));

    //     // Find bottom position of container.
    //     let containerPos = (container.offset().top + container.outerHeight());

    //     let contextPos = (context.offset().top + context.outerHeight());

    //     console.log("context " + contextPos + " || container " + containerPos);

    //     if (contextPos >= containerPos) {
    //         context.addClass('bottom-of-container');

    //         context.css('top', (container.outerHeight() - context.outerHeight))

    //     } else {
    //         context.removeClass('bottom-of-container');
    //     }

    // });

    // Is context the sticky header?
    let isHeader = getIsHeader(id);
    // If not header.
    if (!isHeader) {
        context.on("sticky.zf.stuckto:top", function(event) {
            // Just in case the viewport has shifted remove this class, then re-apply it if needed.
            context.removeClass('element-not-in-viewport');
            // Check to see if sticky element is in viewport, this was point in place as the product enquiry mediamedia container was not in the viewport when sticky was applied on mobile landscape devices.
            if (!getViewPort(context)) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Axis Sticky: Element not in viewport, disabling sticky.", context);
                }
                context.addClass('element-not-in-viewport');
            }
            // Do we have a sticky header? 
            let isHeaderSticky = $('header [' + expressSelectors()['axis-sticky']['initialise'] + ']').length > 0;
            // Fallback until wearesync is done.
            if (!isHeaderSticky) {
                isHeaderSticky = $('#stickyHeader').length > 0;
            }
            // If we do have a sticky header 
            if (isHeaderSticky) {
                let headerSize = getHeaderSize();
                //context.css('top', headerSize);
                context.css('marginTop', headerSize);
    
                context.removeClass('no-animate');
            }
        });
        context.on("sticky.zf.unstuckfrom:bottom", function(event) {
            context.addClass('no-animate');
        });
    } else {
        // Re-calculate the header size, this could be due to a change of breakpoint ( going from desktop => mobile )
        reCalculateHeaderMargin(id);  
    }

    let resizeTimeout;
    // Create an observer 
    let observer = new MutationObserver(function(mutations) {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            let events = context.attr('data-events');

            // Make sure that this is a result of resizing, as as the sticky mechanism changes the inline styles depending on anchored / stuck states.
            if (events == "resize") {
                // If this class is applied then remove it as it may no longer be needed.
                if (context.hasClass('element-not-in-viewport')) {
                    context.removeClass('element-not-in-viewport');
                }
                // // Fire resize event as foundation does not do this.
                context.trigger('axis-sticky-resize', context);
                // Check for carousels.
                let carousels = context.find('[' + expressSelectors()['axis-carousel']['initialise'] + ']');
                if (carousels.length) {
                    if (AXISDebug.level() >= 3) {
                        AXISDebug.output(1,"Axis Sticky: Carousels found attempting to resize.", carousels);
                    }
                    carousels.each(function() {
                        // Carousel context.
                        let carouselContext = $(this);
                        // Do resize.
                        axisCarousel.resize(carouselContext);
                    });
                }
            }
        }, 300);
    });
    // Observer config, specifically looking for style changes.
    observer.observe(context[0], {
        childList: false,
        subtree: false,
        attributes: true,
        attributeFilter: ['style']
    });
}

// When the header is fully rendered re-calulate the other sticky elements.
function reCalculateHeaderMargin(id) {
    // Get current instance context.
    let context = getContext(id);
    // Double check this is the header.
    // Is context the sticky header?
    let isHeader = getIsHeader(id);
    // Check if element is stuck.
    let isStuck = context.hasClass('is-stuck');
    if (isStuck) {
        if (isHeader) {
            context.on('sticky.zf.stuckto:top', function() {
                // Re-calculate margin.
                instancesCalculateMargin(id);
                // Remove listener.
                context.off('sticky.zf.stuckto:top');
            });
        }
    }
}

// Loop through instances recaluting the margin top based on the header height this is to break gaps due to the header changing size.
function instancesCalculateMargin(id) {
    // Loop through instances.
    for (let instance in instances) {
        // Skip instance if it equals the current instace.
        if (instance != id) {

            // Instance context.
            let instanceContext = instances[instance]['context'];
            // is stuck.
            let isStuck = instanceContext.hasClass('is-stuck');
            if (isStuck) {
                // Get instance context and trigger change.
                instanceContext.trigger('sticky.zf.stuckto:top');
            }
            
        }
    }
}

// Pause sticky listeners.
// Use this with caution due to if you call this too soon then the unique scroll listener that gets assigned the $(window) may not be defined yet, in that case this will fall down a hole which also pauses all other scroll listeners as well potentially killing all other sticky instances.
function pauseSticky(id) {
    // Get foundation instance.
    let foundationInstance = getFoundationInstance(id);
    // Build id in a similar way to how foundation does it in foundation.sticky.js as there is a chance that it was not passed back in the object on initialisation.
    let stickyUniquieId = getContext(id).attr('id');
    // Run it through the same logic as in foundation.sticky.js
    stickyUniquieId = stickyUniquieId.split('-').reverse().join('-');
    // Get context.
    let context = getContext(id);
    // Pause sticky scroll listener.
    context.foundation('_pauseListeners', `scroll.zf.${stickyUniquieId}`);
    return true
}

// Un-pause sticky listeners.
function unPauseSticky(id) {
    // Get foundation instance.
    let foundationInstance = getFoundationInstance(id);
    let stickyUniquieId = getContext(id).attr('id');
    // Run it through the same logic as in foundation.sticky.js
    stickyUniquieId = stickyUniquieId.split('-').reverse().join('-');
    // Unpause sticky instance.
    foundationInstance['$element'].foundation('_events', stickyUniquieId);
    return true;
}

function destroySticky(id) {
    // Get Context.
    let context = getContext(id);
    // Get foundation instance.
    let foundationInstance = getFoundationInstance(id);
    // Destroy foundation instance.
    foundationInstance['$element'].foundation('destroy');
    // Clear our instance.
    delete instances[id];
    // Update DOM.
    context.attr(expressSelectors()['axis-sticky']['initialise'], '');
}

var AXISSticky = $.AXISSticky = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context, config) => {
        return initialise(context, config);
    },
    getInstance: (context) => {
        return getInstanceId(context);
    },
    pause: (context) => {
        // Get instance.
        let id = getInstanceId(context);
        if (!id) {
            AXISDebug.output(3,"Sticky: Could not find sticky instance.",context);
            return false;
        }
        // Attempt to unpause.
        return pauseSticky(id);
    },
    unPause: (context) => {
        // Get instance.
        let id = getInstanceId(context);
        if (!id) {
            AXISDebug.output(3,"Sticky: Could not find sticky instance.",context);
            return false;
        }
        // Attempt to unpause.
        return unPauseSticky(id);
    },
    instancesCleanup: () => {
        return instancesCleanup();
    },
    destroy: (context) => {
        // Get instance.
        let id = getInstanceId(context);
        if (!id) {
            AXISDebug.output(3,"Sticky: Could not find sticky instance.",context);
            return false;
        }
        return destroySticky(id);
    }
}
 
export { AXISSticky };
